import { signal } from '@preact/signals';

export type Theme = 'system' | 'light' | 'dark';

export const theme = signal<Theme>((localStorage.getItem('theme') as Theme) || 'system');

export function setTheme(t: Theme) {
  theme.value = t;
  localStorage.setItem('theme', t);
}
